import { IterableItemFactory, IterableListItem } from '../../../../shared/utils/IterableItemFactory'
import { FullDistribution } from '../../Distribution'
import { ConditionType } from '../types'
import {
  ActivityCondition, BoostsCondition, LabelsCondition,
  PossibleConditions, SentCondition, UsersCondition,
  UtmCondition
} from './types'

const iterableItemFactory = new IterableItemFactory()

export type ConditionsState = {
  frConditions: Array<IterableListItem<Array<IterableListItem<PossibleConditions>>>> | null
}

export const state: ConditionsState = {
  frConditions: null,
}

export function convertFrontendToRaw(): FullDistribution['conditions'] {
  return state.frConditions!.map(g => g.value.map(c => c.value))
}

export function convertRawToFrontend(conditions: FullDistribution['conditions']): Array<IterableListItem<Array<IterableListItem<PossibleConditions>>>> {
  if (conditions) {
    return conditions.map(g => iterableItemFactory.create(g.map(c => iterableItemFactory.create(c))))
  }

  return []
}

export function removeGroup(guid: string):void {
  state.frConditions = state.frConditions!.filter(g => g.guid !== guid)
}

export async function addGroup():Promise<string> {
  const group = iterableItemFactory.create([])

  state.frConditions!.push(group)

  return group.guid
}

export function removeCondition(conditionGuid: string, groupGuid: string) {
  const group = state.frConditions?.find(g => g.guid === groupGuid)

  if (group) {
    group.value = group.value.filter(cnd => cnd.guid !== conditionGuid)
  }
}

export function addCondition(parentGuid: string, type: ConditionType) {
  const group = state.frConditions!.find(g => g.guid === parentGuid)

  if (group) {
    switch (type) {
      case ConditionType.Sent:
        group.value.push(iterableItemFactory.create(new SentCondition()))
        break
      case ConditionType.Activity:
        group.value.push(iterableItemFactory.create(new ActivityCondition()))
        break
      case ConditionType.Utm:
        group.value.push(iterableItemFactory.create(new UtmCondition()))
        break
      case ConditionType.Labels:
        group.value.push(iterableItemFactory.create(new LabelsCondition()))
        break
      case ConditionType.Users:
        group.value.push(iterableItemFactory.create(new UsersCondition()))
        break
      case ConditionType.Boosts:
        group.value.push(iterableItemFactory.create(new BoostsCondition()))
        break
      default:
        throw Error(`Unknown type, got: ${ type }`)
    }
  }
}

export function initConditions(conditions: FullDistribution['conditions']) {
    state.frConditions = convertRawToFrontend(conditions)
}
